import { useLazyQuery, useQuery } from "@apollo/client";
import { ARTICLES } from "../article.queries";
import { ArticlesQuery, ArticlesQueryVariables } from "../../../__generated__/ArticlesQuery";

export const useArticles = (variables: ArticlesQueryVariables) => {
  return useQuery<ArticlesQuery, ArticlesQueryVariables>(ARTICLES, { variables });
};

export const useLazyArticles = () => {
  return useLazyQuery<ArticlesQuery, ArticlesQueryVariables>(ARTICLES);
};
